import { BaseGenericItemsStore, GenericItemsForm, GenericItemsUtils, IGetAllParams, MuiDataGrid, MuiIcons } from "@leap4/frontend";
import { urlService } from "../../../routing/urlsService";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../../../../interfaces/root-state.interface";
import { demandBaseUrl } from "../../../../config/generals";
import { useState } from "react";
import { getSavedFilterModel, saveFilterModel } from "../../../../utils/filterUtils";
import { tableNames } from "../../../../common/data/enums";
import {IDemand} from "./demand.interface";

type GridColDef = MuiDataGrid.GridColDef;
const { Toc: TocIcon } = MuiIcons;

// Redux state mapping - get selected organization for refresh on seat change
const mapStateToProps = (state: RootState) => ({
    selectedOrganization: state.auth.selectedOrganizationId
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

// Define fields for the `Demand` entity
const fields = {
    name: 1,
    AdvertisingSystem: 1,
    PubAccId: 1,
    extraAdsTxt: 1,
    globalBundleWhiteList: 1,
    globalBundleBlackList: 1,
    created: 1,
    updated: 1,
};

// Default parameters for fetching `Demand` data
const getParams: IGetAllParams = {
    fields,
    filter: {
        filter: {
            isDeleted: 0,
        },
    },
};

// Variables to hold store and column definitions
let columns: GridColDef[];
let store: BaseGenericItemsStore<IDemand& {_id:string,isActive:boolean}>;

// Function to set up store and columns
function setStoreAndColumns() {
    const storeAndColumns = GenericItemsUtils.GenerateDefaultStoreAndColumns({
        baseUrl: demandBaseUrl,
    }, fields, {
        name:  { editLinkFunc: (_id: string) => urlService.editDemand(_id) },
        isActive: {},
        updated: {},
        created: {},
    });
    store = storeAndColumns.store;
    columns = storeAndColumns.columns;

    const pubAccIdColumn = columns.find((column) => column.field === "PubAccId");
    if (pubAccIdColumn) {
        pubAccIdColumn.renderCell = (params) => {
            const value = params.value;
            if (Array.isArray(value)) {
                return value.map((item) => item.id).join(', ');
            } else {
                return '';
            }
        };
    }

    // Remove the existing extraAdsTxt column, customize it, and then push it as the right-most column.
    const extraAdsTxtColumnIndex = columns.findIndex((column) => column.field === "extraAdsTxt");
    if (extraAdsTxtColumnIndex > -1) {
        const extraAdsTxtColumn = columns.splice(extraAdsTxtColumnIndex, 1)[0];
        extraAdsTxtColumn.headerName = "Extra AdsTxt Lines";
        extraAdsTxtColumn.renderCell = (params) => {
            const value = params.value;
            if (Array.isArray(value) && value.length > 0) {
                return value.filter(item => item != null).join(", ");
            }
            return "";
        };
        columns.push(extraAdsTxtColumn);
    }
}


const DemandDashboard = (props: PropsFromRedux) => {
    const { selectedOrganization } = props;
    setStoreAndColumns();
    const [filterModel, setFilterModel] = useState(() => getSavedFilterModel(tableNames.DEMANDS));

    const handleFilterChange = (newFilterModel) => {
        setFilterModel(newFilterModel || { items: [] });
        saveFilterModel(tableNames.DEMANDS, newFilterModel);
    };

    return (
        <GenericItemsForm
            columns={columns}
            store={store}
            breadcrumbs={{
                link: urlService.demands(),
                text: "Demands Dashboard",
                icon: <TocIcon />,
            }}
            getAllParams={getParams}
            organization={selectedOrganization}
            tableProps={{
                pageSize: 100,
                style: { minHeight: "75vh" },
                componentsProps: {
                    panel: {
                        sx: { top: '-200px !important' },
                    },
                },
                filterModel: filterModel,
                onFilterModelChange: handleFilterChange,
            }}
            createButton={{
                to: urlService.addDemand(),
                text: "Create Demand".toUpperCase(),
            }}
        />
    );
};

export default connector(DemandDashboard);
